import React from 'react';
import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Loader from '@amzn/meridian/loader';
import { useTranslation } from 'src/arb-wrapper';
import { PERMISSION_LIST_PAGE_SIZE } from 'src/store/constants';
import type { BusinessUnitDto } from 'src/store/generated/leela-api-generated';
import { usePlatformAdminControllerFindBusinessUnitsQuery } from 'src/store/leela-api';
import { BuRow } from './BuRow';

interface BuListProps {
  onEdit: (bu: BusinessUnitDto) => void;
}

export const BuList: React.FC<BuListProps> = ({ onEdit }) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = usePlatformAdminControllerFindBusinessUnitsQuery({
    page: 1,
    pageSize: PERMISSION_LIST_PAGE_SIZE,
  });

  if (isLoading) return <Loader />;
  if (isError || !data) {
    return <Alert type="error">{t('bu_management_load_error')}</Alert>;
  }

  const businessUnits = (data as { data?: BusinessUnitDto[] }).data ?? [];

  if (businessUnits.length === 0) {
    return (
      <Text data-testid="bu-management-empty-state" type="b200">
        {t('bu_management_empty')}
      </Text>
    );
  }

  return (
    <Column data-testid="bu-management-list" spacing="300">
      {businessUnits.map((bu: BusinessUnitDto) => (
        <BuRow bu={bu} key={bu.id} onEdit={() => { onEdit(bu); }} />
      ))}
    </Column>
  );
};
